import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MyAccountInfo } from './reporting.models'

export type ReportingRedux = {
  myAccount?: MyAccountInfo
}

export const reportingInitialState: ReportingRedux = {
  myAccount: undefined,
}

export const reportingFeatureKey = 'reporting'

export const reportingSlice = createSlice({
  name: reportingFeatureKey,
  reducers: {
    setFocusedMyAccount: (
      state,
      action: PayloadAction<{ account?: MyAccountInfo }>,
    ) => {
      return { ...state, myAccount: action.payload.account }
    },
  },
  initialState: reportingInitialState,
})

export const { setFocusedMyAccount } = reportingSlice.actions

export default reportingSlice.reducer
